export default __webpack_public_path__ + "static/media/whatsapp-original.09a7fadd.svg";